<template>
  <task-table-view
    :items="items"
    :search="search"
    :isMainView="false"
  ></task-table-view>
</template>

<script>
import TaskTableView from "../task/TaskTableView.vue";
export default {
  components: { TaskTableView },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: "",
    };
  },
};
</script>

<style>
</style>